/*eslint-disable */
import {
  mapGetters
} from 'vuex'; 
const $ = window.jQuery = require('jquery'); 
import axios from 'axios'; 
import toast from '../../services/toast';
export default {
  name: 'user-list-by-organization',
  components: {},
  props: [],
  data () {
    return {
      orgByUserList:{},
      nextStep:'',
      orgByUserListResults:[],
      loadmoreData: {},
      userLoading: false,
      submitted:false,
      chatRequestId:'',
      checkDataTaskModal:false,
      userId:'',
      message:'',
    }
  },
  computed: {
  ...mapGetters([
    'getUserListByOrgGetters',
    'acUserDetailsStateGetters'
  ]),
  getorgByUserListDetailsFun(){
    return this.orgByUserList = this.$store.getters.getUserListByOrgGetters.data
  },
  SetIntialStatus() {
    if (this.orgByUserList != undefined) {
      this.nextStep = this.orgByUserList.next
      this.orgByUserListResults = this.orgByUserList.results
    }
  },
  getUserDetailsAgainFun(){
    this.userId = this.$store.getters.acUserDetailsStateGetters.data
    return
  }
  },
  mounted () {
    this.getUserDetailsAgainFun
    this.getorgByUserListDetailsFun
    this.SetIntialStatus
  },
  methods: {
    chatRequestSend(id){
      this.checkDataTaskModal = true
      this.chatRequestId = id
    },
    closeChatRequestConfirm(){
      this.checkDataTaskModal = false,
      this.chatRequestId = '',
      this.message = ''
    },
    sendChatRequestConfirm(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
            let data = {
              from_user:this.userId.id,
              to_user:this.chatRequestId,
              message:this.message,
            }
            this.userLoading = true
            this.$store.dispatch('SendChatConnectionRequestFun', data)
              .then((res) => {  
                  toast.success(res.data.msg);   
                  this.checkDataTaskModal = false
                  this.chatRequestId = ''  
                  this.message = ''      
                  this.userLoading = false 
              }).catch((error) => {
                toast.error(error.data.data.non_field_errors || error.data.msg);
                this.userLoading = false 
              })
            return;
        }
      });
    }
  },
  watch:{
    getorgByUserListDetailsFun(){
      return this.orgByUserList = this.$store.getters.getUserListByOrgGetters.data
    },
    SetIntialStatus() {
      if (this.orgByUserList != undefined) {
        this.nextStep = this.orgByUserList.next
        this.orgByUserListResults = this.orgByUserList.results
      }
    },
    getUserDetailsAgainFun(){
      return this.$store.getters.acUserDetailsStateGetters.data
    },
  }
}